import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryShowcase() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            内容分类
          </span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            探索精彩<strong>内容世界</strong>
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            六大内容分类，满足您的多元娱乐需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category?cat=${cat.slug}`}
              className="group flex items-center gap-4 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-14 h-14 rounded-xl flex items-center justify-center shrink-0 transition-transform duration-300 group-hover:scale-110 ${
                cat.color === 'primary' ? 'bg-primary-100' : cat.color === 'accent' ? 'bg-accent-100' : 'bg-secondary-100'
              }`}>
                <i className={`${cat.icon} text-2xl ${
                  cat.color === 'primary' ? 'text-primary-600' : cat.color === 'accent' ? 'text-accent-600' : 'text-secondary-600'
                }`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="font-heading text-base text-foreground-900 mb-1">{cat.name}</h3>
                <p className="text-xs text-foreground-500 line-clamp-1">{cat.description}</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 text-lg shrink-0 transition-transform duration-300 group-hover:translate-x-1"></i>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}